import { SegmentButton } from '@ipfabric/ui-components/SegmentedButton/SegmentButton/SegmentButton';
import { SegmentedButton } from '@ipfabric/ui-components/SegmentedButton/SegmentedButton';

type TargetSearchMenuHeaderProps = {
  onChange: (showInterfaces: boolean) => void;
  showInterfaces: boolean;
};

export const TargetSearchMenuHeader = ({
  onChange,
  showInterfaces,
}: TargetSearchMenuHeaderProps) => (
  <>
    <div
      className='flex items-center gap-3xs px-sm py-xs'
      data-testid='assign-labels-target-menu-header'
    >
      <SegmentedButton.Single
        onChange={(value) => onChange(value === 'show')}
        size='small'
        value={showInterfaces ? 'show' : 'hide'}
        variant='outline'
      >
        <SegmentButton value='hide'>Hide</SegmentButton>
        <SegmentButton value='show'>Show</SegmentButton>
      </SegmentedButton.Single>
      <span className='text-xs text-plain'>interfaces</span>
    </div>
    <div className='border-b border-default mx-sm mb-xs' />
  </>
);
